const initialState = {};

const ACTION_TYPES = {
  SET_COLUMN_WIDTH: 'SET_COLUMN_WIDTH',
  SET_ALL_COLUMNS_WIDTHS: 'SET_ALL_COLUMNS_WIDTHS'
};

// eslint-disable-next-line default-param-last
function reducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.SET_COLUMN_WIDTH: {
      const {gridId, columnId, width} = action.payload;
      const currentColumns = state[gridId] || [];

      const updatedColumns = currentColumns.some(col => col.columnId === columnId)
        ? currentColumns.map(col => (col.columnId === columnId ? {...col, width, hasBeenResized: true} : col))
        : [...currentColumns, {columnId, width, hasBeenResized: true}];

      return {
        ...state,
        [gridId]: updatedColumns
      };
    }

    case ACTION_TYPES.SET_ALL_COLUMNS_WIDTHS: {
      const {gridId, columnsWidth} = action.payload;
      return {
        ...state,
        [gridId]: columnsWidth
      };
    }

    default:
      return state;
  }
}

export {reducer, initialState, ACTION_TYPES};
